exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#delete-item .modal-dialog {\n    max-width: 600px;\n    width: 100%;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/shared/image-cropper/image-cropper.component.css
// module id = ../../../../../src/app/shared/image-cropper/image-cropper.component.css
// module chunks = main